const STORAGE_KEY = 'pending-payment-order'
const MAX_AGE_MS = 60 * 60 * 1000

interface PendingPayment {
  url: string
  checkoutPath: string
  thankyouPath: string
  ts: number
}

// Inline <head> script (app.vue), runs before paint on a "back" navigation. Kept as a plain
// string: the SSR build rewrites `window`/`location` inside compiled functions.
// Same rules as redirectToPendingPayment() below.
export const PENDING_PAYMENT_HEAD_SCRIPT = `if((performance.getEntriesByType('navigation')[0]||{}).type==='back_forward'){`
  + `try{var p=JSON.parse(sessionStorage.getItem('${STORAGE_KEY}')||'null'),l=location.pathname;`
  + `if(p&&p.url&&Date.now()-p.ts<=${MAX_AGE_MS}&&l.indexOf(p.checkoutPath)===0&&l.indexOf(p.thankyouPath)!==0)`
  + `{sessionStorage.removeItem('${STORAGE_KEY}');location.replace(p.url)}}catch(e){}}`

export function redirectToPendingPayment() {
  try {
    const pending: PendingPayment | null = JSON.parse(sessionStorage.getItem(STORAGE_KEY) || 'null')
    const path = window.location.pathname
    if (!pending?.url || Date.now() - pending.ts > MAX_AGE_MS) return
    if (path.indexOf(pending.checkoutPath) !== 0 || path.indexOf(pending.thankyouPath) === 0) return
    sessionStorage.removeItem(STORAGE_KEY)
    window.location.replace(pending.url)
  } catch {}
}

export function usePendingPayment() {
  function set(pending: Omit<PendingPayment, 'ts'>) {
    try {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify({
        ...pending,
        checkoutPath: pending.checkoutPath.replace(/\/+$/, ''),
        thankyouPath: pending.thankyouPath.replace(/\/+$/, ''),
        ts: Date.now(),
      }))
    } catch {}
  }

  function clear() {
    try {
      sessionStorage.removeItem(STORAGE_KEY)
    } catch {}
  }

  return { set, clear }
}
